export type Row = Record<string, any>;
let csrf = "";
export async function api(
  path: string,
  options: RequestInit = {},
): Promise<any> {
  const headers = new Headers(options.headers);
  if (!(options.body instanceof FormData))
    headers.set("Content-Type", "application/json");
  if (csrf) headers.set("X-CSRFToken", csrf);
  const response = await fetch(`/api/v1/${path}`, {
    ...options,
    headers,
    credentials: "same-origin",
  });
  if (response.status === 204) return null;
  const text = await response.text();
  let body;
  try {
    body = JSON.parse(text);
  } catch {
    body = { detail: `Respuesta inesperada (${response.status}).` };
  }
  if (!response.ok)
    throw new Error(typeof body === "string" ? body : JSON.stringify(body));
  if (body.csrf) csrf = body.csrf;
  return body;
}
export function post(path: string, body: any) {
  return api(path, { method: "POST", body: JSON.stringify(body) });
}
export async function all(path: string): Promise<Row[]> {
  let result: Row[] = [];
  let next: string | null = path;
  while (next) {
    const data = await api(next);
    if (Array.isArray(data)) return data;
    result = result.concat(data.results);
    next = data.next ? data.next.split("/api/v1/")[1] : null;
  }
  return result;
}
export async function backup() {
  const r = await fetch("/api/v1/respaldo/", {
    method: "POST",
    headers: { "X-CSRFToken": csrf },
  });
  if (!r.ok) throw new Error(await r.text());
  const url = URL.createObjectURL(await r.blob());
  const a = document.createElement("a");
  a.href = url;
  a.download =
    r.headers
      .get("Content-Disposition")
      ?.split('filename="')[1]
      ?.split('"')[0] || "respaldo.zip";
  a.click();
  URL.revokeObjectURL(url);
}
export const fmt = (value: any) =>
  new Intl.NumberFormat("es-EC", { style: "currency", currency: "USD" }).format(
    Number(value || 0),
  );
export function cent(value: string): bigint {
  if (!/^\d+(\.\d{0,2})?$/.test(value)) return 0n;
  const [a, b = ""] = value.split(".");
  return BigInt(a) * 100n + BigInt(b.padEnd(2, "0"));
}
export function decimal(value: bigint): string {
  const sign = value < 0n ? "-" : "";
  const n = value < 0n ? -value : value;
  return `${sign}${n / 100n}.${(n % 100n).toString().padStart(2, "0")}`;
}
